import React from "react";
import Helmet from "react-helmet";
import Progress from "../components/Progress";
import config from "../../data/SiteConfig";

class ProgressPage extends React.Component {
  render() {
    return (
      <div>
        <Helmet title={`Progress | ${config.siteTitle}`} />
        <div className="section">
          <div className="container" style={{paddingTop: "100px"}}>
            <h1 className="title is-1">
              Current Videos in Progress
            </h1>
            <Progress />
          </div>
        </div>
      </div>
    );
  }
}

export default ProgressPage;




// WEBPACK FOOTER //
// ./src/pages/progress.jsx